/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiElement,
  ApiElementFromJSON,
  ApiElementFromJSONTyped,
  ApiElementToJSON,
} from './ApiElement';

/**
 *
 * @export
 * @interface ApiHeaderFooterLevelContent
 */
export interface ApiHeaderFooterLevelContent {
  /**
   *
   * @type {string}
   * @memberof ApiHeaderFooterLevelContent
   */
  type: ApiHeaderFooterLevelContentTypeEnum;
  /**
   *
   * @type {ApiElement}
   * @memberof ApiHeaderFooterLevelContent
   */
  element: ApiElement;
}

/**
 * @export
 */
export const ApiHeaderFooterLevelContentTypeEnum = {
  AvatarHeader: 'avatarHeader',
  Avatar: 'avatar',
  Back: 'back',
  Dismiss: 'dismiss',
  TextLink: 'textLink',
  TextDismiss: 'textDismiss',
  Feedback: 'feedback',
} as const;
export type ApiHeaderFooterLevelContentTypeEnum = typeof ApiHeaderFooterLevelContentTypeEnum[keyof typeof ApiHeaderFooterLevelContentTypeEnum];

export function ApiHeaderFooterLevelContentFromJSON(json: any): ApiHeaderFooterLevelContent {
  return ApiHeaderFooterLevelContentFromJSONTyped(json, false);
}

export function ApiHeaderFooterLevelContentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiHeaderFooterLevelContent {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    type: json['type'],
    element: ApiElementFromJSON(json['element']),
  };
}

export function ApiHeaderFooterLevelContentToJSON(value?: ApiHeaderFooterLevelContent | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    type: value.type,
    element: ApiElementToJSON(value.element),
  };
}
